import React from 'react';
import { Marker } from '@react-google-maps/api';
import { BasicGeo } from '../../../repositories/models/models';
import { useTheme } from '@mui/material';

interface MapMarkerProps {
  markerPosition: BasicGeo;
  markerLabel: string;
}

export default function MapMarker({ markerPosition, markerLabel }: MapMarkerProps) {
  const theme: any = useTheme();

  const svgString = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 6000 6000">
  <defs>
    <style>
      .cls-1 {
        fill: #e65e53;
      }

      .cls-2 {
        fill: #fff;
      }

      .cls-3 {
        fill: none;
      }

      .cls-4 {
        fill: #6f4894;
      }

      .cls-5 {
        clip-path: url(#clippath);
      }
    </style>
    <clipPath id="clippath">
      <path class="cls-3" d="M959.45,1850.9c-22.84-29.44-45.04-57.59-66.75-86.12-109.01-143.28-211.55-291.01-304.13-445.49-69.4-115.8-133.51-234.39-182.42-360.52-25.66-66.19-49.97-132.92-59.12-204.04-18.33-142.34,7.76-275.84,85.6-396.49,112.89-174.99,275.51-271.7,482.78-287.12,195.33-14.53,364.05,49.63,500.3,191.04,105.72,109.71,158.39,242.65,162.67,395.45,2.54,90.62-18.59,175.86-49.11,259.95-47.95,132.15-112.04,256.37-183.28,377.11-112.68,190.97-240.19,371.73-377.66,545.56-2.44,3.09-5.03,6.06-8.88,10.68Z"/>
    </clipPath>
  </defs>
  <!-- Generator: Adobe Illustrator 28.7.1, SVG Export Plug-In . SVG Version: 1.2.0 Build 142)  -->
  <g>
    <g id="Layer_1">
      <g>
        <path class="cls-4" d="M959.45,1850.9c-22.84-29.44-45.04-57.59-66.75-86.12-109.01-143.28-211.55-291.01-304.13-445.49-69.4-115.8-133.51-234.39-182.42-360.52-25.66-66.19-49.97-132.92-59.12-204.04-18.33-142.34,7.76-275.84,85.6-396.49,112.89-174.99,275.51-271.7,482.78-287.12,195.33-14.53,364.05,49.63,500.3,191.04,105.72,109.71,158.39,242.65,162.67,395.45,2.54,90.62-18.59,175.86-49.11,259.95-47.95,132.15-112.04,256.37-183.28,377.11-112.68,190.97-240.19,371.73-377.66,545.56-2.44,3.09-5.03,6.06-8.88,10.68Z"/>
        <g class="cls-5">
          <g>
            <path class="cls-2" d="M1498.45,678.54h-80.14c-231.34,0-419.55-188.21-419.55-419.55h-79.98c0,231.34-188.21,419.55-419.55,419.55v79.98c205.99,0,383.24-125.34,459.54-303.74,50.57,118.25,145.5,213.18,263.75,263.75-178.41,76.3-303.74,253.55-303.74,459.54h79.98c0-231.34,188.21-419.55,419.55-419.55v.16h160.28v-80.14h-80.14Z"/>
            <path class="cls-1" d="M998.76,1178.06h-79.98c0-231.34-188.21-419.55-419.55-419.55v-79.98c275.44,0,499.53,224.09,499.53,499.53Z"/>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>`;

  const iconUrl = `data:image/svg+xml;utf8,${encodeURIComponent(svgString)}`;

  return (
    <Marker
      clickable={false}
      zIndex={99}
      position={markerPosition}
      label={{ text: markerLabel, color: 'black', fontSize: '14px', className: 'mb-6' }}
      icon={iconUrl}
    />
  );
}
